import React, { FC } from 'react'
import { Link } from '@singcolor/components'

type Props = {
  width?: string | number
  height?: string | number
}

export const DownloadOnAppStore: FC<Props> = ({ width, height }) => {
  return (
    <Link isExternal={true} href="https://apps.apple.com/jp/app/id6446391547">
      <img src="/assets/store/apple-badge.svg" width={width ?? 'auto'} height={height ?? 'auto'} />
    </Link>
  )
}

export const DownloadOnGooglePlay: FC<Props> = ({ width, height }) => {
  return (
    <Link isExternal={true} href="https://play.google.com/store/apps/details?id=com.singcolor.app">
      <img src="/assets/store/google-badge.png" width={width ?? 'auto'} height={height ?? 'auto'} />
    </Link>
  )
}
